module.exports = __webpack_public_path__ + "images/FUSA_icons/061-telephone-1.1ac7a5edd5dab0d7484b41ddc6aad5fd.svg";